import type { FormikErrors, FormikTouched } from "formik";
import type React from "react";
import { Form } from "react-bootstrap";
import { FormGroup } from "~/components/common/parts/form/FormGroup";
import { FormLabel } from "~/components/common/parts/form/FormLabel";
import type {
	MailCreateParam,
	MailsCreateParams
} from "~/models/CompanyStoreMail";
import Styles from "./CompanyStoreMailModal.module.scss";

type Props = {
	errors: string | null | FormikErrors<MailCreateParam>;
	handleBlur: (e: React.FocusEvent) => void;
	handleChange: (e: React.ChangeEvent) => void;
	index: number;
	remove: (number: number) => void;
	touched: FormikTouched<MailsCreateParams>;
	values: MailsCreateParams;
};

export const CompanyStoreMailModalRow: React.FC<Props> = ({
	index,
	values,
	remove,
	errors,
	handleBlur,
	handleChange,
	touched
}: Props) => {
	const mailTouched = touched?.companyStoreMails?.[index];
	const mailValues = values?.companyStoreMails?.[index];

	if (typeof errors === "string") {
		return <>{errors}</>;
	}
	return (
		<FormGroup>
			<div className={Styles.MailCreateRow}>
				<div className={Styles.EmailForm}>
					{index === 0 && <FormLabel>メールアドレス</FormLabel>}
					<Form.Control
						isInvalid={!!(mailTouched?.email && errors?.email)}
						name={`companyStoreMails.${index}.email`}
						onBlur={handleBlur}
						onChange={handleChange}
						placeholder="メールアドレスを入力してください"
						type="email"
						value={mailValues?.email}
					/>
					<Form.Control.Feedback type="invalid">
						{errors?.email}
					</Form.Control.Feedback>
				</div>
				<div className={Styles.DelLink}>
					{index !== 0 && (
						<a
							className={Styles.MailDeleteLink}
							href="#"
							onClick={(e: React.MouseEvent): void => {
								e.preventDefault();
								remove(index);
							}}
						>
							削除
						</a>
					)}
				</div>
			</div>
		</FormGroup>
	);
};
